export default __webpack_public_path__ + "static/media/RFDMv.f5bab5b9.webp";